import {
    get_macroAree,
    create_macroArea,
    update_macroArea,
    delete_macroArea,
} from "@/api/api.macroarea.js";

import {
    get_reparti,
    create_reparto,
    update_reparto,
    delete_reparto,
} from "@/api/api.reparto.js";

const configurazione = {
    namespaced: true,

    state: {
        macroAree: [],
        reparti: [],
    },

    mutations: {
        SET_MACRO_AREE: (state, lista) => {
            state.macroAree = lista;
        },
        SET_REPARTI: (state, lista) => {
            state.reparti = lista;
        },
    },

    actions: {
        caricaMacroAree({ commit }) {
            return new Promise((resolve, reject) => {
                get_macroAree().then(resp => {
                    commit("SET_MACRO_AREE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salvaMacroArea({ dispatch }, { id, dati }) {
            const call = id ? update_macroArea(id, dati) : create_macroArea(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("caricaMacroAree");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        eliminaMacroArea({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_macroArea(id).then(resp => {
                    dispatch("caricaMacroAree");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaReparti({ commit }, macroAreaId) {
            return new Promise((resolve, reject) => {
                get_reparti(macroAreaId).then(resp => {
                    commit("SET_REPARTI", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salvaReparto({ dispatch }, { id, dati, macroAreaId }) {
            const call = id ? update_reparto(id, dati) : create_reparto(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("caricaReparti", macroAreaId);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        eliminaReparto({ dispatch }, { id, macroAreaId }) {
            return new Promise((resolve, reject) => {
                delete_reparto(id).then(resp => {
                    dispatch("caricaReparti", macroAreaId);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        macroAree: state => state.macroAree,
        reparti: state => state.reparti,
    },
};

export default configurazione;